import translations from "data/localization"
import { passwordResetRequired, sessionExpired } from "store/slices/authSlice"
import { createApiMessage } from "store/slices/snackbarSlice"

const loginApi = (url = '') => url.includes('/auth/') || url.includes('/auth.pin/')

const extractUsernameFromBasicAuth = (authorization = '') => {
  if (!authorization?.startsWith?.('Basic ')) return ''
  try {
    const decoded = Buffer.from(authorization.slice(6), 'base64').toString('utf8')
    const idx = decoded.indexOf(':')
    return idx >= 0 ? decoded.slice(0, idx) : decoded
  } catch (_) { return '' }
}

const readPasswordResetUsername = (error) => {
  const configMetadataUsername = error?.config?.metadata?.username
  if (configMetadataUsername) return configMetadataUsername
  const authHeader = error?.config?.headers?.Authorization || error?.config?.headers?.authorization
  return extractUsernameFromBasicAuth(authHeader)
}

export const parseErrorMessage = ({ axiosCode, customCode, internalCode, responseStatus, language }) => {
  const defaultLanguage = 'GB'
  return translations[language || defaultLanguage].RequestErrors.custom[customCode]
    || translations[language || defaultLanguage].RequestErrors.internal[internalCode]
    || translations[language || defaultLanguage].RequestErrors.network[responseStatus]
    || translations[language || defaultLanguage].RequestErrors.browser[axiosCode]
    || translations[language || defaultLanguage].RequestErrors.default
}

export const apiErrorSnackbarOptions = (key = 0) => ({
  variant: 'error', key, anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
})

export const globalResponseErrorHandler = (error, store) => {

  const requestUrl = error?.config?.url

  const axiosCode = error?.code || null
  const responseStatus = error?.response?.status || null
  const internalCode = error?.response?.data?.code || 0

  if (internalCode === 0 && error?.message === 'canceled') return 'canceled'

  let message = parseErrorMessage({ internalCode, responseStatus, axiosCode })
  console.warn({ title: 'Global error handler', axiosCode, internalCode, responseStatus, message, error })

  const snackbarSetup = (message, key) => {
    const tempKey = key || new Date().getTime() + Math.random()
    store.dispatch(createApiMessage({ message, key: tempKey, options: apiErrorSnackbarOptions(tempKey) }))
  }

  if (internalCode === 8) {
    const field = error?.response?.data?.message
    if (field) return ({ message, field, code: internalCode })
  }
  if (internalCode === 9) {
    const field = error?.response?.data?.message
    if (field) return ({ message, field, code: internalCode })
  }

  const responseData = error?.response?.data
  if (responseStatus === 403 && (responseData?.password_reset_required === true || internalCode === 10)) {
    const username = readPasswordResetUsername(error)
    const backendMessage = typeof responseData?.message === 'string' ? responseData.message : ''
    store.dispatch(passwordResetRequired({ username, message: backendMessage }))
    return ({ message: backendMessage || message, passwordResetRequired: true, username })
  }

  switch (responseStatus) {
    case 401:
      if (!loginApi(requestUrl)) {
        store.dispatch(sessionExpired())
        snackbarSetup(message, 'unauthenticated')
      } else { snackbarSetup(message) }
      break;

    default:
      snackbarSetup(message)
      break;
  }

  return ({ message, code: internalCode, status: responseStatus })
}